import { either } from 'fp-ts';
import { flow, identity } from 'fp-ts/function';

/**
 * Perform a safe property lookup given data wrapped with Either
 * @abstract (fn: (a: A) -> B) -> A -> Either<E, B>
 */
export function safeGetEither<A = unknown, B = unknown>(getFn: (a: A) => B) {
  return (a: A) => {
    return either.tryCatch(() => getFn(a), identity);
  };
}

/**
 * Use safeGet with default and return the raw value
 * @abstract (fn: (a: A) -> B) -> A -> Either<E, B>
 */
export function safeGet<A = unknown, B = unknown>(getFn: (a: A) => B, defaultValue: B) {
  return flow(
    safeGetEither<A, B>(getFn),
    either.getOrElse(() => defaultValue),
  );
}
